import React from 'react';
import { withAuthorization } from '../Session';
import { Link, withRouter } from 'react-router-dom';

import * as ROUTES from '../../constants/routes';



const RegDonePage = () => (
  <div id="page-reg-done" className="reg-page page">
      <div className="bound-box">
          <h1>Welcome to Hack Makers!</h1>
          <p>Your registeration details has been processed.</p>
          <br/>
          <p><Link className="button" to={ROUTES.DASHBOARD}>BACK TO HOME</Link></p>
      </div>
  </div>
);



export default withAuthorization(authUser => !!authUser)(withRouter(RegDonePage));
